'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var decodeBase64String = exports.decodeBase64String = function decodeBase64String(string) {
  return typeof window === 'undefined' ? Buffer.from(string, 'base64').toString() : window.atob(string);
};

var encodeBase64String = exports.encodeBase64String = function encodeBase64String(string) {
  return typeof window === 'undefined' ? Buffer.from(string).toString('base64') : window.btoa(string);
};